import lodashMemoize from 'lodash-es/memoize';

/** Wrapper around _.memoize to restrict its signature. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- The function signature used (including `any`) is a direct copy from Lodash's `memoize` signature.
export function memoize<T extends (...args: any) => any>(func: T): T {
  return lodashMemoize(func);
}
